import {apiClient} from '@common/http/query-client';

export type SendPackageMode = 'share' | 'link' | 'qr';

export interface PlainCopyPayload {
  sourceEntryId: number;
  plainEntryId: number;
}

export interface E2eeDeliveryPayload {
  fileEntryId: number;
  recipientUserId: number;
  wrappedKey: string;
}

export interface CreateSendPackagePayload {
  mode: SendPackageMode;
  entryIds: number[];
  recipients?: string[];
  subject?: string | null;
  message?: string | null;
  expiresMinutes?: number;
  password?: string | null;
  plainCopies?: PlainCopyPayload[];
  e2eeDeliveries?: E2eeDeliveryPayload[];
}

export interface CreatedSendPackage {
  id: number;
  mode: string;
  expires_at: string;
  access_token?: string;
}

export interface CreateSendPackageResponse {
  sendPackage: CreatedSendPackage;
  receiveUrl: string;
  receivePath: string;
}

export async function createSendPackage(
  payload: CreateSendPackagePayload,
): Promise<CreateSendPackageResponse> {
  const {data} = await apiClient.post<CreateSendPackageResponse>(
    'send-packages',
    payload,
  );
  return data;
}
